import { MDSColors } from "@/mds/foundations/colors";

export const MDSBorderRadius = {
  none: "0px",
  small: "4px",
  medium: "8px",
  large: "16px",
  xlarge: "28px",
  max: "100px",
} as const;

export const MDSTransitions = {
  background: "background 0.08s ease",
} as const;

export const MDSBorders = {
  default: `1px solid ${MDSColors.border.default}`,
} as const;

export const MDSShadows = {
  surface: "0 4px 6px 0 rgba(55, 55, 55, 0.10)",
  tabScrollButtonRight: "-4px 0 6px 0 rgba(17, 17, 26, 0.75)", // TODO: Not in Figma
  tabScrollButtonLeft: "4px 0 6px 0 rgba(17, 17, 26, 0.75)", // TODO: Not in Figma
};

export type IMDSBorderRadius = typeof MDSBorderRadius;
export type IMDSTransitions = typeof MDSTransitions;
export type IMDSBorders = typeof MDSBorders;
export type IMDSShadows = typeof MDSShadows;
